import { __assign, __extends } from "tslib";
/* I119 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Error = /** @class */ (function (_super) {
    __extends(Error, _super);
    function Error() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Error.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("defs", null,
                    React.createElement("path", { d: "M8,16 C3.581722,16 6.21724894e-15,12.418278 7.10542736e-15,8 C7.99360578e-15,3.581722 3.581722,-1.33226763e-15 8,0 C12.418278,8.8817842e-16 16,3.581722 16,8 C16.0005307,10.1218946 15.1578464,12.1570342 13.6574403,13.6574403 C12.1570342,15.1578464 10.1218946,16.0005307 8,16 Z M9,4 L7,4 L7,8.973 L9,8.973 L9,4 Z M8,10 C7.44771525,10 7,10.4477153 7,11 C7,11.5522847 7.44771525,12 8,12 C8.55228475,12 9,11.5522847 9,11 C9,10.4477153 8.55228475,10 8,10 Z", id: "I119-1" })),
                React.createElement("g", { id: "I119-2", stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
                    React.createElement("g", { transform: "translate(4.000000, 4.000000)" },
                        React.createElement("mask", { id: "mask-2", fill: "white" },
                            React.createElement("use", { xlinkHref: "#I119-1" })),
                        React.createElement("use", { id: "Combined-Shape", fillRule: "evenodd", xlinkHref: "#I119-1" }))))));
    };
    return Error;
}(React.Component));
export { Error };
export default Error;
//# sourceMappingURL=Error.js.map